// src/mocks/handlers/funding/commissionsAdvanceDetailsHandler.ts

import { rest } from 'msw';
import advanceDetails from '@/mocks/data/fundingAdvanceDetailsData.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import {
  IAdvanceDetails,
  IAdvanceDetailsResponse,
} from '@/domains/funding/advances.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const fundingAdvanceDetailsHandler = rest.get<IAdvanceDetailsResponse>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.FUNDING_ADVANCE_DETAILS}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const { advance_id } = req.params as { advance_id: string };

    // Mock response data
    const mockResponse = advanceDetails.find(
      (advance) => advance.advance_id === advance_id,
    ) as IAdvanceDetails | undefined;

    if (!mockResponse) {
      return res(
        ctx.status(404),
        ctx.json({ detail: 'Advance details not found' }),
      );
    }
    // Return the mock response
    return res(ctx.status(200), ctx.json(mockResponse));
  },
);
